import { render, staticRenderFns } from "./Space-Dreams.vue?vue&type=template&id=09c2a4b6&scoped=true&"
import script from "./Space-Dreams.vue?vue&type=script&lang=js&"
export * from "./Space-Dreams.vue?vue&type=script&lang=js&"
import style0 from "./Space-Dreams.vue?vue&type=style&index=0&id=09c2a4b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c2a4b6",
  null
  
)

export default component.exports